import React from 'react';
import '../css/ResetPassword.css';
import logoImg from '../public/logoQueruCume.png';

export default function ResetSuccess() {
  const wrapperStyle = {
    background: '#2d2d2d',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    color: '#fff',
    textAlign: 'center',
  };

  return (
    <div style={wrapperStyle}>
      <img
        src={logoImg}
        alt="logo"
        style={{ width: 180, marginBottom: 20 }}
      />
      <div
        style={{
          backgroundColor: '#333',
          borderRadius: 16,
          padding: '40px 30px',
          boxShadow: '0 0 12px rgba(0,0,0,0.5)',
          maxWidth: 400,
        }}
      >
        <h2 style={{ color: '#00ff99', marginBottom: 16 }}>
          Senha alterada com sucesso! 
        </h2>
        <p style={{ color: '#ccc' }}>
          Sua senha foi atualizada com êxito.<br />
          Você já pode fechar esta página com segurança.
        </p>
      </div>
    </div>
  );
}
